import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ModalBase, colors, formatDateTimeShortWithLocale } from 'remote/global';

import { useTranslation } from 'react-i18next';
import { SelectedJoinEventsProps } from 'utils/data/data-types';

type JoinDepoLegsModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose?: () => void;
  onDecline?: () => void;
  onConfirm?: () => void;
  event?: SelectedJoinEventsProps;
};

function JoinDepoLegsModal({
  open,
  onClose,
  setOpen,
  onDecline,
  onConfirm,
  event,
}: JoinDepoLegsModalProps) {
  const { t, i18n } = useTranslation();

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='sm'
      title={t('modals.joinDepoLegs.title').toString()}
      fullWidth
    >
      <Box sx={{ p: [4, null, null, 6], display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            sx={{ fontSize: '16px', fontWeight: 700, lineHeight: '20px', color: colors.uiBlue600 }}
          >
            # {event?.to.bookingNumber}
          </Typography>
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 500,
              color: colors.headerBlack,
              lineHeight: '18px',
            }}
          >
            {t('modals.joinDepoLegs.rideEnd')}
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: '18.2px',
              fontWeight: 400,
              color: colors.uiBlue600,
            }}
          >
            {formatDateTimeShortWithLocale(event?.to.clientEndTime, i18n.language)} -{' '}
            {event?.to.clientEndAddress}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            sx={{ fontSize: '16px', fontWeight: 700, lineHeight: '20px', color: colors.uiBlue600 }}
          >
            # {event?.from.bookingNumber}
          </Typography>
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 500,
              color: colors.headerBlack,
              lineHeight: '18px',
            }}
          >
            {t('modals.joinDepoLegs.rideStart')}
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: '18.2px',
              fontWeight: 400,
              color: colors.uiBlue600,
            }}
          >
            {formatDateTimeShortWithLocale(event?.from.clientStartTime, i18n.language)} -{' '}
            {event?.from.clientStartAddress}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: 'center',
          }}
        >
          <Button variant='outlined' onClick={onDecline}>
            {t('no')}
          </Button>
          <Button onClick={onConfirm}>{t('yes')}</Button>
        </Box>
      </Box>
    </ModalBase>
  );
}

export default JoinDepoLegsModal;
